import { render, staticRenderFns } from "./DetailsPage.vue?vue&type=template&id=8474616c&scoped=true&"
import script from "./DetailsPage.vue?vue&type=script&lang=js&"
export * from "./DetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPage.vue?vue&type=style&index=0&id=8474616c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8474616c",
  null
  
)

export default component.exports